<script lang="ts">
  import { copy } from "../lib/stores/copy";
  import Skin from "../assets/bo7-skin.webp";
  import Charm from "../assets/charm_v2.webp";
  import Emblem from "../assets/emblem_v2.webp";
  import CallingCard from "../assets/calling_card_v2.webp";
  import { isPrimaryCampaign } from "../lib/constants/countries";
  import Points from "../assets/cod-points.webp";

  export let includeMB8: boolean = false;
</script>


{#if isPrimaryCampaign}
  <div class="absolute w-full h-full tabletLg:flex hidden flex-row justify-between">
    <div class="relative laptop:absolute left-0 w-[358px] tabletLg:block hidden">
      <div class="relative">
        <img src={Skin} alt="" class="ml-[-69px] mt-[111px] mb-[-354px]">
        <div class="absolute left-[168px] top-[120px] translate-y-[-50%] max-w-[33%]">
          <div class="font-MrEavesXLSanNarOTUltra leading-[1] text-[13px] text-white font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px]">
            {@html $copy.prizeNames.operatorSkin}
          </div>
        </div>
      </div>
      <div class="flex flex-col absolute top-[8px] left-[287px]">
        <div class="relative w-[147px]">
          <div class="absolute left-0 top-[31%] translate-y-[-50%] w-[35%]">
            <div class="font-MrEavesXLSanNarOTUltra text-[13px] text-right text-white font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px] leading-[1]">
              {$copy.prizeNames.charm}
            </div>
          </div>
          <img src={Charm} alt="">
        </div>
        <div class="relative w-[159px] mt-[-50px] ml-[142px]">
          <div class="font-MrEavesXLSanNarOTUltra text-center text-[13px] text-white font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px]">
            {$copy.prizeNames.emblem}
          </div>
          <img src={Emblem} alt="">
        </div>
        <div class="relative w-[467px] ml-[6px] mt-[5px]">
          <div class="text-right font-MrEavesXLSanNarOTUltra text-[13px] text-white mb-[4px] font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px]">
            {$copy.prizeNames.callingCard}
          </div>
          <img src={CallingCard} alt="">
        </div>
      </div>
    </div>
    <div class={[
      "hidden tabletLg:block",
      "w-[25%] desktopLg:w-[29%]",
      "self-end",
      "absolute right-0 mr-[4%]",
      "top-[250px]",
      "max-w-[550px] max-h-[700px]",
      "laptop:top-0 laptop:h-[calc(100%-1rem)] laptop:flex laptop:flex-col laptop:justify-center"
    ].join(' ')}>
      <div class="mb-4 laptop:mb-12 relative">
        <div class="font-MrEavesXLSanNarOTUltra text-[13px] absolute top-[2%] left-[10%] laptop:left-[25%] min-[1426px]:left-[10%] text-white font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px]">
          {@html $copy.prizeNames.codPoints}
        </div>
        <img src={Points} alt="" class="relative z-[2]">
      </div>
      <p class="font-MrEavesXLSanNarOTUltra text-[18px] whitespace-nowrap text-white font-black leading-[0.9] uppercase text-shadow text-center tablet:text-[18px] laptop:text-[24px] desktop:text-[26px] desktopLg:text-[36px]">
        <span class="font-LCScript text-primary capitalize leading-[0.75] mr-[-0.15em]">{@html $copy.prizeNames.plus}</span>
        {@html $copy.prizeNames.youCanWinSplit}
      </p>
    </div>
    <!-- Gradient overlay -->
    <div class="absolute top-[650px] bottom-[-10px] left-0 right-0 pointer-events-none z-[10]" style="background: linear-gradient(to bottom, transparent 0%, rgb(0, 0, 0) 100px, rgb(0, 0, 0) 100%);"></div>
  </div>
{:else}
  <div class="absolute w-full h-full tabletLg:flex hidden flex-row justify-between p-8">
    <div class="w-[358px] flex flex-col gap-[150px]">
      <div class="flex flex-row items-center gap-4">
        <img src={Emblem} alt="" class="w-[159px]">
        <div class="flex flex-col diffuse-text-shadow">
          <div class="font-MrEavesXLSanNarOTUltra leading-[1] text-[13px] text-white font-black uppercase laptop:text-[15px] desktopLg:text-[17px]">
            {$copy.prizeNames.firstPurchase}
          </div>
          <div class="font-MrEavesXLSanNarOT leading-[1] text-[13px] text-white font-black uppercase laptop:text-[15px] desktopLg:text-[17px]">
            {$copy.prizeNames.oneInGameEmblem}
          </div>
        </div>
      </div>
      <div class="relative flex flex-col gap-4" class:mb-8={includeMB8}>
        <img src={Charm} alt="" class="absolute bottom-[75px] right-[-25px] w-[107px]">
        <div class="flex flex-col diffuse-text-shadow">
          <div class="font-MrEavesXLSanNarOTUltra leading-[1] text-[13px] text-white font-black uppercase laptop:text-[15px] desktopLg:text-[17px]">
            {$copy.prizeNames.secondPurchase}
          </div>
          <div class="font-MrEavesXLSanNarOT leading-[1] text-[13px] text-white font-black uppercase laptop:text-[15px] desktopLg:text-[17px]">
            {$copy.prizeNames.oneInGameCharm}
          </div>
          <div class="font-MrEavesXLSanNarOT leading-[1] text-[13px] text-white font-black uppercase laptop:text-[15px] desktopLg:text-[17px]">
            {$copy.prizeNames.oneInGameCallingCard}
          </div>
        </div>
        <div class="w-[467px]">
          <img src={CallingCard} alt="" class="w-[467px]">
        </div>
      </div>
    </div>
    <div class="relative w-[408px] pr-[50px]">
      <img src={Skin} alt="">
      <div class="absolute top-[85px] left-[240px]">
        <div class="font-MrEavesXLSanNarOTUltra leading-[1] text-[13px] text-white font-black uppercase laptop:text-[15px] desktopLg:text-[17px]">
          {$copy.prizeNames.thirdPurchase}
        </div>
        <div class="font-MrEavesXLSanNarOT leading-[1] text-[13px] text-white font-black uppercase laptop:text-[15px] desktopLg:text-[17px]">
          {$copy.prizeNames.oneInGameOperatorSkin}
        </div>
      </div>
    </div>
    <!-- Gradient overlay -->
    <div class="absolute top-[550px] bottom-[-10px] left-0 right-0 pointer-events-none z-[10]" style="background: linear-gradient(to bottom, transparent 0%, rgb(0, 0, 0) 100px, rgb(0, 0, 0) 100%);"></div>
  </div>
{/if}